import { render, staticRenderFns } from "./folders-ports-countries-contacts-files.vue?vue&type=template&id=7c1850a3&scoped=true"
import script from "./folders-ports-countries-contacts-files.vue?vue&type=script&lang=js"
export * from "./folders-ports-countries-contacts-files.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1850a3",
  null
  
)

export default component.exports